import { createAsyncThunk } from "@reduxjs/toolkit"
import { getCreditHistoryApi, getTransactionHistoryApi } from "../../apis"

export const transactionHistoryAction = createAsyncThunk("transaction/history", async (data: any, { rejectWithValue }) => {
    try {
        const response = await getTransactionHistoryApi(data)
        return response.data
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "Could not get user transaction history" })
    }
})

export const getCreditHistoryAction = createAsyncThunk("get/credit/history", async ( _, { rejectWithValue }) => {
    try {
        const response = await getCreditHistoryApi()
        return response.data
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "Could not get user credit history" })
    }
})